<style lang="scss" scoped>
  @import "./advanced.scss";
</style>
<script>

import {
  CONSTANT,
  CHECKOUT_METHODS,
  CHECKOUT_EXPERIENCE_LABELS,
  CHECKOUT_EXPERIENCES,
  DEFAULT_CHECKOUT_EXPERIENCE,
  BOOLEAN_OPTIONS,
  AUTH_FLOW_OPTIONS,
  AUTH_PRESENTATION_OPTIONS
} from '../../../utils/constant.js'
import checkout from '../../../utils/checkout'
import { mapGetters } from 'vuex'
import consumer from '../../../utils/consumer'
import { EventBus } from '@/event-bus'
import JsonEditorComponent from '../../shared/json-editor/json-editor.vue'

export default {
  components: {
    JsonEditorComponent
  },
  data () {
    return {
      CONSTANT: CONSTANT,
      checkoutMethods: CHECKOUT_METHODS,
      checkoutExperiences: CHECKOUT_EXPERIENCES,
      checkoutExperienceLabels: CHECKOUT_EXPERIENCE_LABELS,
      booleanOptions: BOOLEAN_OPTIONS,
      enableMBL: false,
      cofDpaids: [],
      dpaId: null,
      disableEnroll: true,
      payloadResponse: null,
      scofDigitalCardId: null,
      srcCorrelationId: null,
      isSaveCardOnFile: true,
      isDataEdited: false,
      requestData: {},
      authExecutionFlowOptions: AUTH_FLOW_OPTIONS,
      authPresentationOptions: AUTH_PRESENTATION_OPTIONS
    }
  },

  computed: {
    cofOnOff: {
      get () {
        return this.$store.state.configuration.cofOnOff
      },

      set (value) {
        this.$store.dispatch('updateCOFOnOff', value)
      }
    },
    checkoutMethod: {
      get () {
        return this.$store.getters.checkoutMethod || 'direct'
      },

      set (value) {
        this.updateCheckoutMethod(value)
      }
    },
    cofDigitalCardId: {
      get () {
        return this.$store.state.configuration.advanced.cofDigitalCardId
      },

      set (value) {
        this.$store.dispatch('updateCOFDigitalCardId', value)
      }
    },
    cofSrciTxId: {
      get () {
        return this.$store.state.configuration.advanced.cofSrciTxId
      },

      set (value) {
        this.$store.dispatch('updateCOFSrciTxId', value)
      }
    },
    srcNetwork: {
      get () {
        return this.$store.getters.srcNetwork
      }
    },
    selectedCheckoutExperience: {
      get () {
        return this.$store.state.configuration.advanced.selectedCheckoutExperience || DEFAULT_CHECKOUT_EXPERIENCE
      },
      set (value) {
        this.$store.commit('updateSelectedCheckoutExperience', value)
      }
    },

    ...mapGetters(['supportMobileLookup', 'dpaIds', 'encryptedcard'])
  },
  created () {
    if (consumer.getDecryptedData() && this.encryptedcard) {
      this.getLastCheckoutData()
      this.disableEnroll = false
    }
  },
  mounted () {
    this.enableMBL = this.supportMobileLookup
    this.cofDpaids = this.dpaIds.filter((dpa) => {
      return dpa['displayDpaName'].includes('COF')
    })
    this.dpaId = this.cofDpaids[0]
    EventBus.$on('enrollCardResponse', (response) => {
      this.scofDigitalCardId = response.enrollCardResponse.maskedCard.srcDigitalCardId
      this.srcCorrelationId = response.enrollCardResponse.srcCorrelationId
    })
  },
  methods: {

    retrievePaymentDetails () {
      const srcCorrelationId = this.$store.state.configuration.srcCorrelationId
      checkout.callSrcPayLoad(srcCorrelationId, this.cofDigitalCardId, this.srcNetwork)
    },

    callPayload () {
      this.$store.commit('loaderOn', true)
      checkout.callSrcPayLoad(this.srcCorrelationId, this.scofDigitalCardId, this.srcNetwork, this.isSaveCardOnFile, this.dpaId.dpa[0].dpaId)
    },

    updateCheckoutMethod (checkoutMethod) {
      this.$store.commit('commitCheckoutMethod', checkoutMethod)
      window.location.reload()
    },

    updateMobileLookup () {
      this.$store.commit('updateSupportMobileLookup', this.enableMBL)
    },

    /**
     * common function to get pre checkout and payload data
     */
    getLastCheckoutData () {
      let lastCheckoutData = JSON.parse(localStorage.getItem('lastCheckoutData') || {})
      this.checkoutData = lastCheckoutData['checkoutResponse']
      this.checkoutResponse = this.checkoutData['checkoutResponse']
      this.payloadResponse = this.getDecryptedData()
    },

    /**
     * get decrypted payload data
     * @returns {*|{maskedConsumer: (*|{srcConsumerId: string, maskedConsumerMobileNumber: (*|{phoneNumber: (*|string), countryCode: *}), countryCode: string, maskedEmailAddress: *, maskedFirstName: *, maskedLastName: *}), encryptedPayload: string, shippingCountryCode: *, maskedCard: (*|{tokenLastFour: string, panBin: string, dcf: (*|{name: string, logoUri: string, type: string, uri: string}), dateOfCardLastUsed: string, countryCode: string, panLastFour: *, digitalCardData: (*|{presentationName: string, artWidth: number, artUri: string, descriptorName: string, artHeight: number, status: string}), panExpirationYear: *, srcDigitalCardId: string, tokenBin: string, billingAddress: (*|{zip: string, city: string, countryCode: string, state: string, line2: string, line1: (*|string)}), dateOfCardCreated: string, digitalCardStatus: string, panExpirationMonth: *}), shippingAddressZip: *, srcDigitalCardId: string, shippingAddressId: string, srcCorrelationId: string}}
     */
    getDecryptedData () {
      const _decryptedData = consumer.getDecryptedData()
      return consumer.getPayloadResponse(_decryptedData)
    },

    enrollCard () {
      this.$store.commit('loaderOn', true)
      const srcCorrelationId = this.$store.state.configuration.srcCorrelationId
      checkout.callEnroll(srcCorrelationId, this.payloadResponse, this.encryptedcard, this.dpaId.dpa[0].dpaId, this.srcNetwork)
      this.$store.commit('loaderOn', false)
    },

    updateRequestParam (updatedData) {
      this.isDataEdited = true
      this.requestData = updatedData
    }

  }

}
</script>

<template>
  <div
    v-if="$store.state.configuration.userAccessToken"
    id="configuration-advanced"
  >
    <div class="card mb-4">
      <h5
        aria-controls="checkoutMethodSelection"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#checkoutMethodSelection"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t ('label.chooseCheckoutMethod') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>

      <div
        id="checkoutMethodSelection"
        class="card-body collapse show"
      >
        <h5>{{ $t ('label.chooseCheckoutMethod') }}</h5>
        <div
          id="checkoutMethod"
          class="row mt-3 radioButtons"
        >
          <div class="col-sm-12">
            <label
              v-for="(value, key) in checkoutMethods"
              :key="key"
            >
              <input
                :id="'radio-' + key"
                v-model="checkoutMethod"
                :value="key"
                type="radio"
              >
              <div class="btn">{{ value.description }}</div>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-4">
      <h5
        id="selectCheckoutExperienceHeader"
        aria-controls="selectCheckoutExperienceBody"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#selectCheckoutExperienceBody"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t ('label.selectCheckoutExperience') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>
      <div
        id="selectCheckoutExperienceBody"
        class="card-body collapse show"
      >
        <label>{{ $t ('label.chooseCheckoutExperience') }}</label>
        <div
          v-for="checkoutExperience in checkoutExperiences"
          :key="checkoutExperience"
          class="form-check mt-3"
        >
          <input
            :id="checkoutExperience"
            v-model="selectedCheckoutExperience"
            :value="checkoutExperience"
            class="form-check-input"
            type="radio"
            name="checkoutExperienceSelection"
          >
          <label
            :for="checkoutExperience"
            class="form-check-label ml-2"
          >
            {{ checkoutExperienceLabels[checkoutExperience] }}
          </label>
          <div class="clear" />
        </div>
      </div>
    </div>
    <div
      v-show="false"
      class="card mb-4">
      <h5
        aria-controls="cof"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#cof"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t ('label.cardOnFile') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>

      <div
        id="cof"
        class="card-body collapse show"
      >
        <h5>{{ $t ('label.enableCOF') }}</h5>
        <div
          id="cof-preference"
          class="row mt-3 radioButtons"
        >
          <div class="col-sm-12">
            <label
              v-for="(key, value) in CONSTANT.CONFIG.COF_TESTING_ENABLE"
              :key="value"
              class="cof-OnOff"
            >
              <input
                :id="'radio-' + value"
                v-model="cofOnOff"
                :value="key"
                type="radio"
              >
              <div class="btn">{{ value }}</div>
            </label>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            {{ $t ('label.digitalCardId') }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-12">
            <input
              id="input-cofDigitalCardId_value"
              v-model="cofDigitalCardId"
              :disabled="!cofOnOff"
              class="form-control"
              type="text"
            >
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            {{ $t ('label.srciTxId') }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-12">
            <input
              id="input-cofSrciTxId"
              v-model="cofSrciTxId"
              :disabled="!cofOnOff"
              class="form-control"
              type="text"
            >
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            <button
              id="generate-btn"
              :class="[ !(cofOnOff && !!cofDigitalCardId) ? 'btn-secondary disabled' : 'btn-primary' ]"
              :disabled="!(cofOnOff && !!cofDigitalCardId)"
              class="btn"
              data-cy="generate-button"
              type="button"
              @click="retrievePaymentDetails()"
            >
              {{ $t ('label.paymentDetailsCOF') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4">
      <h5
        aria-controls="scof"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#scof"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t ('label.secureCardOnFile') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>

      <div
        id="scof"
        class="card-body collapse show"
      >
        <div class="row mt-2">
          <div class="col-sm-12">
            {{ $t ('label.dpaId') }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-12">
            <select
              id="select-dpa-id"
              v-model="dpaId"
              class="option-dpa form-control"
              data-test="select-dpa-id"
              @change="updateDpaId(dpaIdIndex)"
            >
              <option
                v-for="(dpa,index) in cofDpaids"
                :key="index"
                :value="dpa"
              >
                {{ dpa.displayDpaName }}
              </option>
            </select>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            <label class="font-weight-bold mb-1">{{ $t ('label.srciDpaId') }}</label>
            <p v-if="dpaId">{{ dpaId.dpa[0].dpaId }}</p>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-12">
            <button
              id="generate-btn"
              :class="[ disableEnroll ? 'btn-secondary disabled' : 'btn-primary' ]"
              :disabled="disableEnroll"
              class="btn btn-primary"
              data-cy="generate-button"
              type="button"
              @click="enrollCard()"
            >
              {{ $t ('label.enrollCard') }}
            </button>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            {{ $t ('label.digitalCardId') }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-12">
            <input
              id="input-cofDigitalCardId_value"
              v-model="scofDigitalCardId"
              :disabled="!scofDigitalCardId"
              class="form-control"
              type="text"
            >
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            <button
              id="generate-btn"
              :class="[ !scofDigitalCardId ? 'btn-secondary disabled' : 'btn-primary' ]"
              :disabled="!scofDigitalCardId"
              class="btn"
              data-cy="generate-button"
              type="button"
              @click="callPayload()"
            >
              {{ $t ('label.paymentDetailsSCOF') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-4">
      <h5
        id="Supportmobilelookup"
        aria-controls="selectMobileLookup"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#selectMobileLookup"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t ('label.mobileLookup') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>
      <div
        id="selectMobileLookup"
        class="card-body collapse show"
      >
        <div class="form-group row">
          <label
            class="col-sm-3 col-form-label"
            for="supportMBL">{{ $t ('label.supportMBL') }}
          </label>
          <div class="col-sm-9">
            <select
              id="supportMBL"
              v-model="enableMBL"
              class="form-control"
              @change="updateMobileLookup"
            >
              <option
                v-for="val in booleanOptions"
                :key="val.key"
                :value="val.value"
              >
                {{ val.key }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
